var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76 52",
    style: {
      enableBackground: "new 0 0 76 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,26c0,1.1-0.9,2-2,2H12c-1.1,0-2-0.9-2-2s0.9-2,2-2h18C31.1,24,32,24.9,32,26z M26,38H12c-1.1,0-2,0.9-2,2s0.9,2,2,2h14 c1.1,0,2-0.9,2-2S27.1,38,26,38z M30,10H12c-1.1,0-2,0.9-2,2s0.9,2,2,2h18c1.1,0,2-0.9,2-2S31.1,10,30,10z M76,2v48c0,1.1-0.9,2-2,2 H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h72C75.1,0,76,0.9,76,2z M72,4H4v44h68V4z M65.9,40c0,1.1-0.9,2-2,2H36c-1.1,0-2-0.9-2-2 c0-6.6,3.9-12.2,9.6-14.7c-1.9-1.9-3.2-4.5-3.2-7.3c0-5.3,4.4-10,9.5-10s9.5,4.7,9.5,10c0,2.8-1.2,5.4-3.2,7.3 C61.9,27.8,65.9,33.4,65.9,40z M44.4,18c0,2.8,2.4,6,5.5,6s5.5-3.2,5.5-6s-2.4-6-5.5-6S44.4,15.2,44.4,18z M61.8,38 c-0.9-5.7-5.9-10-11.8-10s-10.8,4.3-11.8,10H61.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4f0b46ea2f6c3af275655ed738cbb0b3.svg";
export { ForwardRef as ReactComponent };